export default __webpack_public_path__ + "static/media/sa-title-cn.238fcdeb.webp";